import { createAction } from '@reduxjs/toolkit'

export const resetForNewClient = createAction('resetForNewClient')
